






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Snackbar extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(String) text!: string
}
